import { type FC } from "react"
import Typography from "@mui/material/Typography"
import { DateTime } from "luxon"

import type { TableStatColumn } from "types/dashboard.types"

interface TimestampCellProps {
  column: TableStatColumn
  time?: string
}

const TimestampCell: FC<TimestampCellProps> = ({ column, time }) => {
  const formatted = time ? DateTime.fromISO(time).toFormat("yyyy-MM-dd HH:mm:ss") : "—"

  return (
    <Typography
      fontWeight="700"
      fontSize="0.8rem"
      noWrap
      textAlign={column.align ?? "left"}
    >
      {formatted}
    </Typography>
  )
}

export default TimestampCell
